// WhatsApp Kullanım ve Sorumluluk Beyanı — tam metin (sunucudan düz metin, satır sonlarıyla).

import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import {
  dialogActionsSx,
  dialogCancelButtonSx,
  dialogContentSx,
  dialogMessageSx,
  dialogPaperSx,
  dialogTitleSx,
} from "../../../components/common/dialogStyles";
import { COLORS, TYPO } from "../../../styles/uiConstants";

export default function DeclarationDialog({ open, onClose, text, version }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: dialogPaperSx }}>
      <DialogTitle sx={dialogTitleSx}>WhatsApp Kullanım ve Sorumluluk Beyanı</DialogTitle>
      <DialogContent sx={dialogContentSx}>
        {version ? (
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate400, mb: 1.5 }}>Sürüm {version}</Typography>
        ) : null}
        <Box
          sx={{
            maxHeight: "55vh",
            overflowY: "auto",
            overscrollBehavior: "contain",
            border: `1px solid ${COLORS.slate200}`,
            borderRadius: 2,
            bgcolor: COLORS.slate50,
            p: 2,
          }}
        >
          <Typography sx={{ ...dialogMessageSx, whiteSpace: "pre-wrap", color: COLORS.slate700 }}>
            {text || "Beyan metni yüklenemedi."}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={dialogActionsSx}>
        <Button onClick={onClose} variant="outlined" sx={dialogCancelButtonSx}>
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
